import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Sprout, Trophy, Users, Shield, Award } from 'lucide-react';
const PROGRAMS = [{
  icon: Sprout,
  age: 'Ages 3–5',
  title: 'Mini Troopers',
  href: '/mini-troopers'
}, {
  icon: Trophy,
  age: 'Ages 6+',
  title: 'Kids Taekwondo',
  href: '/karate-kids-classes.html'
}, {
  icon: Sparkles,
  age: 'Adults',
  title: 'Adult Classes',
  href: '/karate-adult-classes'
}, {
  icon: Users,
  age: 'All Ages',
  title: 'Family Classes',
  href: '/FamilyKarateClasses.html'
}, {
  icon: Shield,
  age: 'Adults',
  title: 'Self-Defense',
  href: '/self-defense-classes-in-farmington-hills-michigan'
}, {
  icon: Award,
  age: 'Kids & Teens',
  title: 'Competition Team',
  href: '/taekwondo-competitions-in-farmington-hills-michigan'
}];
export function Page31Programs() {
  return <section className="py-24 bg-off-white" data-id="element-2808">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2809">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-2810">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-2811">
            Storm Classes & Programs
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-2812">
            Storm Taekwondo serves kids, adults, and families in Farmington
            Hills and across Southeast Michigan. Pick what fits — or tell us
            about you on the form and a Storm coach will recommend the right
            starting class.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2813">
          {PROGRAMS.map((p, i) => <Link key={i} to={p.href} className="group bg-paper border border-subtle-gray rounded-2xl p-6 flex flex-col gap-3 hover:border-storm-red transition-colors" data-id="element-2814">
              <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red group-hover:bg-storm-red group-hover:text-white transition-colors" data-id="element-2815">
                <p.icon className="w-6 h-6" data-id="element-2816" />
              </div>
              <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-2817">
                {p.age}
              </p>
              <h3 className="text-lg text-ink leading-tight" data-id="element-2818">{p.title}</h3>
              <span className="text-storm-red font-bold text-sm group-hover:underline" data-id="element-2819">
                Learn more →
              </span>
            </Link>)}
        </div>

        <div className="text-center mt-10" data-id="element-2820">
          <Link to="/Programs.html" className="text-storm-red font-bold hover:underline inline-flex items-center gap-1" data-id="element-2821">
            See All Programs →
          </Link>
        </div>
      </div>
    </section>;
}